import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import SideBar from '../admincomponents/SideBar';
import TopNavBar from '../admincomponents/TopNavBar';
import Footer from '../admincomponents/Footer';
const apiUrl = process.env.REACT_APP_API_URL;
function AdminViewCourse() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true);
      setError('');
      try {
        const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
        if (!sessionData || !sessionData.token) {
          setError('You must be logged in to view courses.');
          setLoading(false);
          return;
        }
        const response = await axios.get(`${apiUrl}/api/admin/courses?nocache=${Date.now()}`, {
          headers: {
            Authorization: `Bearer ${sessionData.token}`
          }
        });
        if (response.data.success) {
          setCourses(response.data.courses);
        } else {
          setError(response.data.message || 'Failed to fetch courses.');
        }
      } catch (err) {
        console.error('Error fetching courses:', err);
        setError(err.response?.data?.message || 'Error fetching courses. Please try again.');
      } finally {
        setLoading(false);
      }
    };
    fetchCourses();
  }, []);
  return (
    <>
      <SideBar />
      <div className="dashboard-main-wrapper">
        <TopNavBar />
        <div className="dashboard-body">
          <div className="breadcrumb-with-buttons mb-24 flex-between flex-wrap gap-8">
            <div className="breadcrumb mb-24">
              <ul className="flex-align gap-4">
                <li>
                  <Link
                    to="/"
                    className="text-gray-200 fw-normal text-15 hover-text-main-600"
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <span className="text-gray-500 fw-normal d-flex">
                    <i className="ph ph-caret-right" />
                  </span>
                </li>
                <li>
                  <span className="text-main-600 fw-normal text-15">Courses</span>
                </li>
              </ul>
            </div>
            <div className="flex-align gap-8 flex-wrap">
              <div className="position-relative text-gray-500 flex-align gap-4 text-13">
                <span className="text-inherit">Sort by: </span>
                <div className="flex-align text-gray-500 text-13 border border-gray-100 rounded-4 ps-20 focus-border-main-600 bg-white">
                  <span className="text-lg">
                    <i className="ph ph-funnel-simple" />
                  </span>
                  <select className="form-control ps-8 pe-20 py-16 border-0 text-inherit rounded-4 text-center">
                    <option value="popular" selected>Popular</option>
                    <option value="latest">Latest</option>
                    <option value="trending">Trending</option>
                  </select>
                </div>
              </div>
              <div className="flex-align text-gray-500 text-13 border border-gray-100 rounded-4 ps-20 focus-border-main-600 bg-white">
                <span className="text-lg">
                  <i className="ph ph-layout" />
                </span>
                <select
                  className="form-control ps-8 pe-20 py-16 border-0 text-inherit rounded-4 text-center"
                  id="exportOptions"
                >
                  <option value="" selected disabled>
                    Export
                  </option>
                  <option value="csv">CSV</option>
                  <option value="json">JSON</option>
                </select>
              </div>
            </div>
          </div>
          <div className="card overflow-hidden">
            <div className="card-body p-0 overflow-x-auto">
              {loading && (
                <div className="alert alert-info mb-0" role="alert">
                  Loading courses...
                </div>
              )}
              {error && (
                <div className="alert alert-danger mb-0" role="alert">
                  {error}
                </div>
              )}
              {!loading && !error && courses.length === 0 && (
                <div className="alert alert-warning mb-0" role="alert">
                  No courses found.
                </div>
              )}
              {!loading && !error && courses.length > 0 && (
                <table id="courseTable" className="table table-striped">
                  <thead>
                    <tr>
                      <th className="fixed-width">
                        <div className="form-check">
                          <input
                            className="form-check-input border-gray-200 rounded-4"
                            type="checkbox"
                            id="selectAll"
                          />
                        </div>
                      </th>
                      <th className="h6 text-gray-300">Course Name</th>
                      <th className="h6 text-gray-300">Summary</th>
                      <th className="h6 text-gray-300">Image</th>
                      <th className="h6 text-gray-300">Duration</th>
                      <th className="h6 text-gray-300">Fees</th>
                      <th className="h6 text-gray-300">Status</th>
                      <th className="h6 text-gray-300">Created</th>
                      <th className="h6 text-gray-300">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {courses.map((course) => (
                      <tr key={course.id}>
                        <td className="fixed-width">
                          <div className="form-check">
                            <input
                              className="form-check-input border-gray-200 rounded-4"
                              type="checkbox"
                            />
                          </div>
                        </td>
                        <td>
                          <span className="h6 mb-0 fw-medium text-gray-300">
                            {course.coursename.length > 30
                              ? `${course.coursename.substring(0, 30)}...`
                              : course.coursename}
                          </span>
                        </td>
                        <td>
                          <span className="h6 mb-0 fw-medium text-gray-300">
                            {course.coursesummary.length > 50
                              ? `${course.coursesummary.substring(0, 50)}...`
                              : course.coursesummary}
                          </span>
                        </td>
                        <td>
                          {course.courseimage ? (
                            <img
                              src={`${apiUrl}/${course.courseimage}`}
                              alt={course.coursename}
                              className="w-40 h-40 rounded"
                            />
                          ) : (
                            <span>No Image</span>
                          )}
                        </td>
                        <td>
                          <span className="h6 mb-0 fw-medium text-gray-300">
                            {course.courseduration.length > 20
                              ? `${course.courseduration.substring(0, 20)}...`
                              : course.courseduration}
                          </span>
                        </td>
                        <td>
                          <span className="h6 mb-0 fw-medium text-gray-300">
                            {isNaN(parseFloat(course.fees))
                              ? 'N/A'
                              : `₹${parseFloat(course.fees).toFixed(2)}`}
                          </span>
                        </td>
                        <td>
                          <span
                            className={`text-13 py-2 px-8 bg-${
                              course.status === 1 ? 'success' : 'warning'
                            }-50 text-${
                              course.status === 1 ? 'success' : 'warning'
                            }-600 d-inline-flex align-items-center gap-8 rounded-pill`}
                          >
                            <span
                              className={`w-6 h-6 bg-${
                                course.status === 1 ? 'success' : 'warning'
                              }-600 rounded-circle flex-shrink-0`}
                            />
                            {course.status === 1 ? 'Active' : 'Inactive'}
                          </span>
                        </td>
                        <td>
                          <span className="h6 mb-0 fw-medium text-gray-300">
                            {new Date(course.created).toLocaleDateString()}
                          </span>
                        </td>
                        <td>
                          <Link
                            to={`/admin-edit-course/${course.id}`}
                            className="bg-main-50 text-main-600 py-2 px-14 rounded-pill hover-bg-main-600 hover-text-white"
                          >
                            Edit
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
            <div className="card-footer flex-between flex-wrap">
              <span className="text-gray-900">
                Showing {courses.length} of {courses.length} entries
              </span>
              <ul className="pagination flex-align flex-wrap">
                <li className="page-item active">
                  <a
                    className="page-link h-44 w-44 flex-center text-15 rounded-8 fw-medium"
                    href="#"
                  >
                    1
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
export default AdminViewCourse;